const boardCells = [
  [
    {
      value: 0,
      color: '#0ABF00',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
  ],
  [
    {
      value: 3,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 6,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 9,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 12,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 15,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 18,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 21,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 24,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 27,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 30,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 33,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 36,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: -1,
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
  ],
  [
    {
      value: 2,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 5,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 8,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 11,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 14,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 17,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 20,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 23,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 26,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 29,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 32,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 35,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: -2,
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
  ],
  [
    {
      value: 1,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 4,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 7,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 10,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 13,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 16,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 19,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 22,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 25,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 28,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 31,
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 34,
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: -3,
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
  ],

  [
    {
      value: '1-12',
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: '13-24',
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: '25-36',
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
  ],
  [
    {
      value: '1-18',
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 'even',
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 'red',
      color: '#200052',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 'black',
      color: '#2c2c2c',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: 'odd',
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
    {
      value: '19-36',
      color: '#111111',
      chips: [
        { value: 1, count: 0 },
        { value: 10, count: 0 },
        { value: 100, count: 0 },
        { value: 1000, count: 0 },
        { value: 10_00000, count: 0 },
        { value: 100_00000, count: 0 },
        { value: 500_00000, count: 0 },
      ],
    },
  ],
];

export default boardCells;
